<template>
  <div class="all">
    <div class="all-msg">
      <div class="base-msg">
        <p
          style="
            font-size: 18px;
            font-weight: 400;
            color: #2d3748;
            margin: 40px 0 10px 0;
          "
        >
          应用基本信息
        </p>
        <div class="base">
          <!-- 弹出窗 -->
          <div class="base-pop -intro-x" id="more-oprate" v-show="isPop">
            <!-- <div
              class="div"
              @click="btnState('2', '已停用!')"
              v-if="newData.state == '1'"
            >
              停用此软件
            </div>
            <div
              class="div"
              @click="btnState('1', '已启用!')"
              v-if="newData.state == '2'"
            >
              启用此软件
            </div> -->
            <div class="div" @click="btnRedact">编辑</div>
            <div class="div">新增该应用终端</div>

            <div class="div" @click="getConnection">
              <a
                style="height: 100%; width: 100%; display: inline-block"
                :href="newData.domain_adm"
                target="_blank"
                >前往后台设置</a
              >
            </div>
          </div>

          <!--  -->
          <div class="base-img">
            <div class="card_header">
              <div class="img-box">
                <div class="LeftPng" v-if="newData.icon">
                  <img
                    style="width: 100%; height: 100%"
                    :src="newData.icon"
                    alt=""
                  />
                </div>

                <div
                  class="LeftPng"
                  :style="'background:' + CardData.color"
                  v-else
                >
                  <img src="@/assets/images/niao.png" alt="" />
                </div>
              </div>

              <div class="cardRihgt">
                <div class="icon-box" @click="isPop = true">
                  <i
                    class="el-icon-more"
                    style="font-size: 20px; color: #1890ff"
                  ></i>
                </div>
              </div>
              <div class="cardRight2">
                <img :src="CardDataImg" alt="" />
                <span>{{ CardData.module_count }}个模块</span>
              </div>
            </div>
          </div>
          <div class="CardDataName">{{ CardData.name }}</div>

          <div>
            <p style="font-size: 12px; color: #718096; overflow: hidden">
              <span
                style="
                  float: left;
                  width: 60%;
                  overflow: hidden;
                  height: 20px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
                >应用主名称：{{ newData.name || "未命名应用未命名应用" }}</span
              >

              <span style="float: right">{{ CardData.create_time }} 创建</span>
            </p>
          </div>

          <p
            style="margin: 20px 0 10px 0; border-bottom: 1px solid #f5f5f5"
          ></p>

          <div class="base-content">
            <div class="div-p">
              <span class="div-p1">版本信息：</span>
              <span v-if="newData.platform_info">{{
                newData.platform_info
              }}</span>

              <span v-else style="color: #ff4242">生成中</span>
            </div>

            <div class="div-p">
              <span class="div-p1">APPKEY：</span>
              <!--                            <span v-if="newData.state === '1' " ></span>-->
              <span style="color: #ff4242">生成中</span>
            </div>
            <div class="div-p">
              <span class="div-p1"> 到期时间：</span>
              <span>{{ CardData.expire }}</span>
            </div>
            <div class="div-p">
              <span v-if="newData.state === '0'" class="div-p1">
                应用状态：<span style="color: #333333">等待创建应用</span></span
              >
              <span v-if="newData.state === '1'" class="div-p1">
                应用状态：<span style="color: #333333">应用已创建</span></span
              >
              <span v-if="newData.state === '2'" class="div-p1">
                应用状态：<span style="color: #333333">已停用</span></span
              >
              <span v-if="newData.state === ''" class="div-p1">
                应用状态：<span style="color: #ff4242">等待配置</span></span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="config-msg">
        <p
          style="
            font-size: 18px;
            font-weight: 400;
            color: #2d3748;
            margin: 40px 0 10px 0;
          "
        >
          配置信息
        </p>
        <div class="config">
          <p style="margin-top: 10px; padding-bottom: 5px">
            <el-switch
              v-model="isSwitch"
              inactive-text="信息展示"
              :active-value="true"
              :inactive-value="false"
              @change="onSwitch"
            >
            </el-switch>

            <span class="font-right" @click="isYuMing = true">{{
              yuMinBtn
            }}</span>
          </p>
          <p style="margin: 5px 0 10px 0; border-bottom: 1px solid #f5f5f5"></p>
          <div class="config-p">
            <span
              v-if="!newData.domain && !newData.domain_wap_custom"
              style="color: #ff4242"
              >配置中</span
            >

            <span v-else-if="isSwitch" class="config-span">
              商业域名：<span style="color: #2c2c2c">{{
                isYuanYou2 ? newData.domain_wap_custom : newData.domain
              }}</span></span
            >
            <span v-else class="config-span">
              商业域名：<span style="color: #2c2c2c">{{
                isYuanYou2
                  ? newData.domain_wap_custom
                  : newData.domain | numFilte
              }}</span></span
            >

            <span
              v-if="newData.domain_wap_custom"
              class="tapYuMing"
              :class="{ isYuanYou: isYuanYou2, isBianji: !isYuanYou2 }"
              @click="isYuanYou2 = !isYuanYou2"
              >{{ isYuanYou2 ? "查看原域名" : "查看自定义域名" }}</span
            >

            <el-button
              v-clipboard:copy="
                isYuanYou2 ? newData.domain_wap_custom : newData.domain
              "
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              type="primary"
              size="mini"
              round
              >复制</el-button
            >
          </div>

          <div class="config-p">
            <span
              v-if="!newData.domain_api && !newData.domain_api_custom"
              style="color: #ff4242"
              >配置中</span
            >

            <span v-else-if="isSwitch" class="config-span">
              小程序地址：<span style="color: #2c2c2c">{{
                isYuanYou3 ? newData.domain_api_custom : newData.domain_api
              }}</span></span
            >
            <span v-else class="config-span">
              小程序地址：<span style="color: #2c2c2c">{{
                isYuanYou3
                  ? newData.domain_api_custom
                  : newData.domain_api | numFilte
              }}</span></span
            >

            <span
              v-if="newData.domain_api_custom"
              class="tapYuMing"
              :class="{ isYuanYou: isYuanYou3, isBianji: !isYuanYou3 }"
              @click="isYuanYou3 = !isYuanYou3"
              >{{ isYuanYou3 ? "查看原域名" : "查看自定义域名" }}</span
            >

            <el-button
              v-clipboard:copy="
                isYuanYou3 ? newData.domain_api_custom : newData.domain_api
              "
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              type="primary"
              size="mini"
              round
              >复制</el-button
            >
          </div>

          <div class="config-p">
            <span
              v-if="!newData.domain_adm && !newData.domain_admin_custom"
              style="color: #ff4242"
              >配置中</span
            >

            <span v-else-if="isSwitch" class="config-span">
              后台管理地址：<span style="color: #2c2c2c">{{
                isYuanYou ? newData.domain_admin_custom : newData.domain_adm
              }}</span></span
            >
            <span v-else class="config-span">
              后台管理地址：<span style="color: #2c2c2c">{{
                isYuanYou
                  ? newData.domain_admin_custom
                  : newData.domain_adm | numFilte
              }}</span></span
            >

            <span
              v-if="newData.domain_admin_custom"
              class="tapYuMing"
              :class="{ isYuanYou: isYuanYou, isBianji: !isYuanYou }"
              @click="isYuanYou = !isYuanYou"
              >{{ isYuanYou ? "查看原域名" : "查看自定义域名" }}</span
            >

            <el-button
              v-clipboard:copy="
                isYuanYou ? newData.domain_admin_custom : newData.domain_adm
              "
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              type="primary"
              size="mini"
              round
              >复制</el-button
            >
          </div>

          <div class="config-2p">
            <div class="config-p1">
              <span v-if="!newData.adm_user" style="color: #ff4242"
                >配置中</span
              >

              <span v-if="isSwitch" class="config-span"
                >超级管理员账号：<span style="color: #2c2c2c">{{
                  newData.adm_user
                }}</span></span
              >
              <span v-else class="config-span"
                >超级管理员账号：<span style="color: #2c2c2c">{{
                  newData.adm_user | numFilte
                }}</span></span
              >

              <el-button
                v-clipboard:copy="newData.adm_user"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                type="primary"
                size="mini"
                round
                >复制</el-button
              >
            </div>
            <div class="config-p1" v-if="newData.adm_psw">
              <span v-if="isSwitch" class="config-span"
                >超级管理员密码：<span style="color: #2c2c2c">{{
                  newData.adm_psw
                }}</span></span
              >
              <span v-else class="config-span"
                >超级管理员密码：<span style="color: #2c2c2c">{{
                  newData.adm_psw | numFilte
                }}</span></span
              >

              <el-button
                v-clipboard:copy="newData.adm_psw"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                type="primary"
                size="mini"
                round
                >复制</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="version-msg">
        <p
          style="
            font-size: 18px;
            font-weight: 400;
            color: #2d3748;
            margin: 40px 0 10px 0;
          "
        >
          版本信息
        </p>
        <div class="version">
          <div v-if="newData.pay_mode === '0'" class="version-p">授信版</div>
          <div v-if="newData.pay_mode === '1'" class="version-p">支付版</div>
          <div class="version-p1">
            <!--                        <span>可用额度</span> <span style="margin-left: 55%; color: #1890FF">1234/9897</span>-->
            <!--                        <el-progress  :strokeWidth="4"  :percentage="60" :format="format"></el-progress>-->
          </div>
          <p
            style="
              margin: 20px 0 10px 0;
              border-bottom: 1px solid #f5f5f5;
              margin-bottom: 40px;
            "
          ></p>
          <div class="version-p1">
            <span>APP版本：</span>
            <span v-if="newData.app_version" class="floatRight">{{
              newData.app_version
            }}</span>
            <span v-else style="float: right; color: #ff4242">生成中</span>
          </div>

          <div class="version-p1">
            <span>后台版本：</span>
            <span v-if="newData.srv_version" class="floatRight">{{
              newData.srv_version
            }}</span>
            <span v-else style="float: right; color: #ff4242">生成中</span>
          </div>
          <div class="version-p1">
            <span>智莺版本：</span>
            <span
              v-if="newData.pay_mode === '0'"
              style="float: right; color: #2c2c2c"
              >授信版</span
            >
            <span
              v-if="newData.pay_mode === '1'"
              style="float: right; color: #2c2c2c"
              >支付版</span
            >
          </div>
          <div class="version-p1">
            <span>APP功能：</span>
            <span class="floatRight" v-if="newData.info">{{
              newData.info
            }}</span>
            <span v-else style="float: right; color: #ff4242">生成中</span>
          </div>
          <el-button v-if="newData.pay_mode === '1'" type="primary" round
            >转换成为授信版</el-button
          >
          <el-button v-else type="primary" round>升级成为付费版</el-button>
        </div>
      </div>
    </div>
    <div class="buy-module">
      <p
        style="
          font-size: 18px;
          font-weight: 400;
          color: #2d3748;
          margin: 20px 0 0 0px;
        "
      >
        已购模块
      </p>
      <div
        class="module"
        v-for="(item, index) in newData.modules_item"
        :key="index"
      >
        <div class="left3Header">
          <img :src="item.icon" alt="" />
          <!-- <i
            class="xb el-icon-more-outline"
            style="font-size: 28px; color: #bbc6da"
          ></i> -->
          <span class="have-bought">已购买</span>
        </div>

        <div class="left3Content">
          <h2>{{ item.title }}</h2>
          <div>{{ item.subtitle }}</div>
        </div>
      </div>
    </div>
    <div class="menu-module">
      <ul>
        <li class="menu-item" @click="changeItemClass('official')">
          <p
            style="
              font-size: 18px;
              font-weight: 400;
              color: #2d3748;
              margin: 20px 0 0 20px;
            "
          >
            官方推荐模块
          </p>
        </li>
      </ul>
      <div class="buy-module">
        <div
          class="module"
          v-for="(item, index) in newData.store_modules_item"
          :key="index"
        >
          <div class="left3Header">
            <img :src="item.icon" alt="" />
            <!-- <i
              class="xb el-icon-more-outline"
              style="font-size: 28px; color: #bbc6da"
            ></i> -->

            <span class="have-bought" v-if="item.is_has">已购买</span>

            <span class="spanButton" v-else>购买 ¥ {{ item.money }}</span>
          </div>

          <div class="left3Content">
            <h2>{{ item.title }}</h2>
            <div>{{ item.subtitle }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isRedactPoP">
      <Redact
        @cancelPop="cancelPop"
        :redactData="CardData"
        :newData="this.newData"
      />
    </div>

    <div class="YuMing-box" v-if="isYuMing">
      <div class="shade-box" @click="isYuMing = false"></div>
      <div class="showToast">
        <div class="toast-heade">自有域名设置</div>
        <div class="toast-content">
          <div>
            <el-checkbox v-model="adminLabel">使用自有管理后台域名</el-checkbox>
            <p class="input-box">
              <el-input v-model="adminVal" placeholder="请输入内容"></el-input>
            </p>
          </div>
          <div>
            <el-checkbox v-model="apiLabel">使用自有API域名</el-checkbox>
            <p class="input-box">
              <el-input v-model="apiVal" placeholder="请输入内容"></el-input>
            </p>
          </div>
          <div>
            <el-checkbox v-model="h5Label">使用自有H5域名</el-checkbox>
            <p class="input-box">
              <el-input v-model="h5Val" placeholder="请输入内容"></el-input>
            </p>
          </div>
        </div>

        <div class="toast-bottom">
          <div class="div1" @click="isYuMing = false">取消</div>
          <div class="div2" @click="tapSave">保存设置</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../utils/request";
import Redact from "../modules/Redact";

export default {
  components: {
    Redact,
  },
  // 過濾器
  filters: {
    numFilte(val) {
      return (
        // String(val).substring(0, 3) +
        "*********"
        // String(val).substring(7, 13)
      );
    },
  },
  data() {
    return {
      isYuMing: false,
      apiLabel: false,
      adminLabel: false,
      h5Label: false,
      isYuanYou: false,
      isYuanYou2: false,
      isYuanYou3: false,
      value1: true,
      CardData: {},
      yuMinBtn: "绑定自有域名",
      h5Val: "",
      adminVal: "",
      apiVal: "",
      module: 5,
      percentage: "",
      strokeWidth: 0,
      // 默认显示板块
      isATC: "official",
      // 應用詳情數據
      newData: {},
      // 隱藏開關
      isSwitch: false,
      isPop: false,
      baseIem: 0,
      isRedactPoP: false,
    };
  },
  activated() {
    this.CardData = this.$route.query;
    this.uuid = this.$route.query.uuid;
    this.platform = this.$route.query.platform;
    this.getAppDatails();
  },
  created() {
    // console.log("appdetails created = " + JSON.stringify(this.CardData))
    // 点击其他位置关闭弹窗
    document.addEventListener("mouseup", (e) => {
      var _con = document.getElementById("more-oprate");
      if (_con) {
        if (!_con.contains(e.target)) {
          this.isPop = false;
        }
      }
    });
    this.$forceUpdate();
  },

  methods: {
    // 保存
    tapSave: function () {
      request({
        url: "/api/myApp/addDomain",
        method: "POST",
        data: {
          uuid: this.uuid,
          domain_api_custom: this.apiLabel ? this.apiVal : "",
          domain_admin_custom: this.adminLabel ? this.adminVal : "",
          domain_wap_custom: this.h5Label ? this.h5Val : "",
        },
      }).then((res) => {
        if (res.code === 0) {
          this.isYuMing = false;
          this.apiLabel ? this.apiVal : (this.apiVal = ""),
            this.adminLabel ? this.adminVal : (this.adminVal = ""),
            this.h5Label ? this.h5Val : (this.h5Val = "");

          if (
            (this.apiVal && this.apiLabel) ||
            (this.adminLabel && this.adminVal) ||
            (this.h5Label && this.h5Val)
          ) {
            this.yuMinBtn = "编辑自有域名";
          } else {
            this.yuMinBtn = "绑定自有域名";
          }

          if (this.apiVal === "") {
            this.apiLabel = false;
          }

          if (this.adminVal === "") {
            this.adminLabel = false;
          }
          if (this.h5Val === "") {
            this.h5Label = false;
          }
          this.getAppDatails();
          this.$message.success("修改成功");
        }
      });
    },

    getDomain: function (uuid) {
      request({
        url: `/api/myApp/domain/${uuid}`,
      }).then((res) => {
        this.apiVal = res.data.domain_api_custom;
        this.adminVal = res.data.domain_admin_custom;
        this.h5Val = res.data.domain_wap_custom;
        this.apiLabel = res.data.domain_api_custom ? true : false;
        this.adminLabel = res.data.domain_admin_custom ? true : false;
        this.h5Label = res.data.domain_wap_custom ? true : false;

        if (
          res.data.domain_api_custom ||
          res.data.domain_admin_custom ||
          res.data.domain_wap_custom
        ) {
          this.yuMinBtn = "编辑自有域名";
        } else {
          this.yuMinBtn = "绑定自有域名";
        }
      });
    },

    cancelPop: function () {
      this.isRedactPoP = false;
      this.getAppDatails();
    },
    // 停用
    btnState: function (val, msg) {
      request({
        url: "/api/app/state",
        method: "POST",
        data: {
          uuid: this.uuid,
          state: val,
        },
      }).then((res) => {
        if (res.code === 0) {
          this.$message.success(msg);
          this.newData.state = val;
        }

        this.isPop = false;
      });
    },

    // 获取应用-应用详情
    getAppDatails: function () {
      const loading = this.$loading({
        lock: true,
        text: "加载中···",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      request({
        url: `/api/myApp/detail/${this.uuid}/${this.platform}`,
      })
        .then((res) => {
          if (res.code === 0) {
            console.log(JSON.parse(JSON.stringify(res)));
            res.data.store_modules_item.forEach((item) => {
              let money = 0;
              let platform = item.platform.split(",");
              for (let i in platform) {
                money = money + Number(item[`cost_price_${platform[i]}`]);
              }
              item.money = money;
            });
            this.getDomain(this.uuid);
            this.newData = res.data;
            // this.CardDatas = JSON.parse(JSON.stringify(res.data));
            // console.log(this.newData)
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },

    btnRedact: function () {
      this.isPop = false;
      this.isRedactPoP = true;
    },

    getConnection: function () {
      this.isPop = false;
    },

    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success("内容已复制到剪切板！");
    },
    // 复制失败时的回调函数
    onError(e) {
      this.$message.error("抱歉，复制失败！");
    },
    // 改变模块样式
    changeItemClass(value) {
      this.isATC = value;
    },
    // 进度条
    format(percentage) {
      return percentage === 100 ? "满" : `${percentage}%`;
    },

    onSwitch: function () {
      console.log(this.isSwitch);
    },
  },
  computed: {
    CardDataImg: function () {
      var url = null;
      if (this.CardData.platform === "ios") {
        url = require("../assets/images/ios.png");
      }
      if (this.CardData.platform === "android") {
        url = require("../assets/images/anzhuo.png");
      }
      if (this.CardData.platform === "web") {
        url = require("../assets/images/h5.png");
      }

      if (this.CardData.platform === "applet") {
        url = require("../assets/images/xiaochengxu.png");
      }

      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
.all-msg {
  width: 100%;
  .base-msg {
    display: inline-block;
    margin-right: 20px;
    width: 290px;
    .base {
      position: relative;
      padding: 20px;
      height: 327px;
      background: #ffffff;
      box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
      opacity: 1;
      border-radius: 22px;
      box-sizing: border-box;
      .base-img {
        .card_header {
          /*background: red;*/
          width: 100%;
          font-size: 16px;

          color: #333333;
          overflow: hidden;
          margin-bottom: 5px;
        }

        .img-box {
          float: left;
          .LeftPng {
            width: 75px;
            height: 75px;
            line-height: 75px;
            text-align: center;
            border-right: 16px;
            overflow: hidden;
            border-radius: 23px;
            position: relative;
          }

          .LeftPng > img {
            display: inline-block;
            width: 50px;
            vertical-align: -15px;
          }
        }
        .cardRihgt {
          float: right;
          margin: 0 0 5px 10px;
        }
        .icon-box {
          width: 32px;
          height: 32px;
          text-align: center;
          line-height: 32px;
          border: 1px solid #1890ff;
          box-sizing: border-box;
          border-radius: 50%;
          cursor: pointer;
        }
        .cardRight2 {
          width: 105px;
          height: 32px;
          border: 1px solid #bbc6da;
          border-radius: 16px;
          float: right;
          color: #bbc6da;
          font-size: 12px;
          line-height: 32px;
          font-weight: 400;
          position: relative;
          text-indent: 40px;
        }
        .cardRight2 > img {
          height: 32px;
          width: 32px;
          border-radius: 50%;
          position: absolute;
          left: -1px;
          top: -1px;
        }
      }
      .base-content {
        .div-p {
          font-size: 14px;
          margin: 12px 0;
          .div-p1 {
            color: #718096;
            width: 70px;
          }
        }
      }
    }
  }
  .config-msg {
    display: inline-block;
    vertical-align: top;
    margin-right: 1%;
    width: 59%;
    min-width: 610px;

    .config {
      width: 100%;
      padding: 0 2% 2% 2%;
      height: 327px;
      background: #ffffff;
      box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
      opacity: 1;
      border-radius: 22px;
      overflow: hidden;
      .el-switch_label {
        /*line-height: 1;*/
        /*font-size: 16px;*/
        /*display: inline-block;*/
        color: red;
      }
      .config-p {
        padding: 0 10px;
        width: 100%;
        height: 50px;
        background: #fafafa;
        font-size: 15px;
        line-height: 50px;
        border-radius: 22px;
        margin: 12px 0;
        position: relative;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .el-button {
          position: absolute;
          top: 10px;
          right: 18px;
        }
        .config-span {
          color: #718096;
          white-space: nowrap;
          min-width: 300px;
          overflow: hidden;
        }
      }
      .config-2p {
        display: flex;
        justify-content: space-between;
        .config-p1 {
          font-size: 15px;
          line-height: 50px;
          margin: 10px 10px 10px 0;
          padding-left: 10px;
          width: 100%;
          height: 50px;
          background: #fafafa;
          border-radius: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          .el-button {
            position: absolute;
            top: 10px;
            right: 18px;
          }
          .config-span {
            color: #718096;
          }
        }
        .config-p1:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .version-msg {
    display: inline-block;
    vertical-align: top;
    width: 290px;

    .version {
      padding: 20px;
      width: 100%;
      height: 327px;
      background: #ffffff;
      box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
      border-radius: 22px;
      box-sizing: border-box;
      .el-button {
        margin-top: 20px;
        width: 100%;
        height: 50px;
      }
      .version-p {
        font-size: 18px;
        color: #2d3748;
      }
      .version-p1 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 10px 0;
        font-size: 14px;
        color: #7d8ba0;
      }
    }
  }
}
.buy-module {
  float: left;
  width: calc(100% + 1.5%);
  .module {
    width: 18.4%;
    padding: 20px;
    float: left;
    min-width: 220px;
    height: 214px;
    background: #ffffff;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
    border-radius: 22px;
    margin: 1.5% 1.5% 1.5% 0;
    box-sizing: border-box;
    .left3Header {
      position: relative;
      .xb {
        position: absolute;
        /*background: red;*/
        top: 0;
        right: 0;
      }
      img {
        height: 83px;
        width: 83px;
        display: inline-block;
        border-radius: 20px;
      }

      .have-bought {
        padding: 2px 12px;
        background: #edf2f7;
        color: #718096;
        font-size: 14px;
        border-radius: 7px;
        vertical-align: bottom;
        float: right;
        margin-top: 60px;
      }
      .spanButton {
        padding: 2px 12px;
        background: #1890ff;
        color: #fff;
        font-size: 14px;
        border-radius: 7px;
        vertical-align: bottom;
        float: right;
        margin-top: 60px;
      }

      .spanButton:active {
        background: rgb(61, 154, 241);
      }
    }
    .left3Content {
      width: 100%;
      margin-top: 20px;
      h2 {
        color: #2d3748;
        font-size: 16px;
        margin-bottom: 5px;
      }
      div {
        color: #718096;
        font-size: 14px;
      }
    }
  }
}
.menu-module {
  float: left;
  width: 100%;
  .menu-item {
    float: left;
    padding-bottom: 5px;
    margin-right: 15px;
    position: relative;
    cursor: pointer;
  }
  .itemACT {
    color: #1890ff;
  }
  .itemACT::before {
    position: absolute;
    bottom: 0;
    left: 8px;
    height: 4px;
    width: 100%;
    content: "";
    background: #1890ff;
    border-radius: 10px;
  }
}

.base-pop {
  width: 200px;
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  position: absolute;
  border-radius: 20px;
  right: 20px;
  top: 57px;
  line-height: 46px;
  color: #bbc6da;
  font-size: 14px;
  overflow: hidden;
  .div {
    padding: 0 16px;
    cursor: pointer;
  }
  .div:hover {
    color: #1890ff;
    background: #f7f8fb;
  }
}

.CardDataName {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.floatRight {
  width: calc(100% - 70px);
  float: right;
  color: #2c2c2c;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.font-right {
  float: right;
  background: #1890ff;
  font-size: 14px;
  color: #fff;
  line-height: 14px;
  padding: 6px 20px;
  border-radius: 16px;
}

.font-right:active {
  background: rgba(61, 154, 241, 0.7);
}

.YuMing-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  .shade-box {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.1);
  }

  .showToast {
    width: 460px;
    height: 464px;
    background: #fff;
    border-radius: 22px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto auto;
    .toast-heade {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: 400;
      box-sizing: border-box;
      padding: 0 20px;
      color: #333333;
      width: 100%;
      border-bottom: 1px solid #f4f4f4;
    }
    .toast-content {
      padding: 0 20px 30px;
      width: 100%;
      margin-top: 20px;
      border-bottom: 1px solid #f4f4f4;
      .input-box {
        padding: 8px 0 20px;
        .el-input__inner {
          border-radius: 12px;
        }
      }
    }

    .toast-bottom {
      height: 80px;
      line-height: 80px;
      text-align: right;
      font-size: 14px;
      padding: 0 20px;
      div {
        display: inline-block;
        line-height: 14px;
        border-radius: 6px;
        box-sizing: border-box;
        padding: 11px 20px;
      }
      .div1 {
        border: 1px solid #e2e8f0;
        margin-right: 10px;
      }

      .div1:active {
        background: rgba(235, 235, 235, 0.3);
      }

      .div2 {
        background: #1890ff;
        color: #fff;
      }

      .div2:active {
        background: rgba($color: #1890ff, $alpha: 0.5);
      }
    }
  }
}

.tapYuMing {
  position: absolute;
  right: 75px;
  top: 10px;
  margin-right: 10px;
  padding: 0 14px;
  border: 1px solid #4ca5ff;
  font-size: 12px;
  height: 28px;
  line-height: 28px;
  box-sizing: border-box;
  border-radius: 16px;
}

.isYuanYou {
  color: #1890ff;
  background: #fff;
  transition: background-color 0.6s, width 0.3s, color 0.5s;
  width: 90px;
}

.isYuanYou:active {
  background: rgba(243, 243, 243, 0.7);
}

.isBianji {
  color: #fff;
  background: #4ca5ff;
  transition: background-color 0.6s, width 0.3s, color 0.5s;
  width: 114px;
}

.isBianji:active {
  background: rgba($color: #409eff, $alpha: 0.7);
}

@media screen and (max-width: 1880px) {
  .version-msg {
    width: 100% !important;
    display: block;
  }

  .config-msg {
    width: calc(100% - 310px) !important;
    margin-right: 0 !important;
  }
}

@media screen and (max-width: 500px) {
  .module {
    width: 100%;
  }
}

@media screen and (max-width: 1520px) {
 
  .buy-module {
    float: left;
    width: 100%;
    .module {
      padding: 5px 10px;
      width: 23.4%;
 
    }
  }
 
}

@media screen and (max-width: 1125px) {
  .base-msg {
    width: 100% !important;
  }

  .config-msg {
    width: 100% !important;
    min-width: 100% !important;
    margin-right: 0 !important;
  }
}

@media screen and (max-width: 1140px) {
  .buy-module {
    float: left;
    width: 100%;
    .module {
      padding: 5px 10px;
      width: 31.8%;
      .spanButton {
        padding: 2px 2px !important;
        font-size: 12px !important;
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .buy-module {
    float: left;
    width: 100%;
    .module {
      padding: 5px 10px;
      width: 25% !important;
      min-width: 48.5% !important;
      .spanButton {
        padding: 2px 2px !important;
        font-size: 12px !important;
      }
    }
  }
}
</style>